//处理业务显示js文件
import  Vue from "vue";
import moment from 'moment';
import {Status, StatusObj} from "../enum/generalEnum";


/**
 * 数字千分位
 * num: number
 * return string | number
 */
Vue.filter("thousandths", (num)=>{
    if(typeof num === "number"){
        return num.toLocaleString()
    }else{
        return num;
    }
})
/**
 * 时间格式化
 * formatString：日期格式
 */
 Vue.filter('timeFormat', (value, formatString) => {
  formatString = formatString || 'MM-DD HH:mm';
  return moment(value).format(formatString);
});
Vue.filter('timeFireFoxFormat', (value, formatString) => {
  formatString = formatString || 'HH:mm:ss';
  if (moment(value).isValid()) {
    // 谷歌
    return moment(value).format(formatString);
  }else{
    // 火狐
    return (value+'').split(' ')[1]
  }
});
/**
 * 启用 0 禁用 1
 * 根据 value 返回 label 文本
 */
Vue.filter("getStatusText", (num) => {
    if(StatusObj[num] !== undefined){
        return StatusObj[num].label
    }else{
        return num
    }
})
Vue.filter('nullToDefault', (num) => {
  return num == null ? '--' : num;
});
Vue.filter("zeroDefault", (num) => {
    if(num == 0||num==0.00){
        return '--'
    }else{
        return num
    }
})
/**
* 校验只要是数字（包含正负整数，0以及正负浮点数）就返回true
**/

function isNumber(val){
  return typeof(val)=="number"; 
  // var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  // var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  // if(regPos.test(val) && regNeg.test(val)){
  //     return true;
  // }else{
  //     return false;
  // }
}
//四舍五入保留2位小数（若第二位小数为0，则保留一位小数）-数据类型不变
function keepTwoDecimal(num){
  let result=parseFloat(num);
  if(isNaN(result)){
    return num;
  }
  result=Math.round(num*100)/100;
  return result;
}
//保留两位小数
Vue.filter("numFormatDefault", (num) => {
  if(isNumber(num)){
    return keepTwoDecimal(num);
  }else{
    return num;
  }
})
//将数字转为xx万
Vue.filter("numUnit", (num) => {
  if(isNumber(num)){
    return keepTwoDecimal(num/10000);
  }else{
    return num;
  }
})
/**
 * 能耗数据统一规则
100以下保留一位小数
100~9999保留整数
1万以上显示为x.x万
以此类推
 */
Vue.filter("energyFormat", (num) => {
  // console.log('isNumber1 :>> ', num,isNumber(num));
  if(isNumber(num)){
    // console.log('isNumber :>> ', num);
    let res='';
    if(num<100){
      res=num.toFixed(2);
    }else if(num>=100&&num<10000){
      res=num.toFixed(0);
    }else if(num>=10000&&num<100000000){
      res=keepTwoDecimal(num/10000).toFixed(2)+'万'
    }
    else if(num>=100000000){
      res=keepTwoDecimal(num/100000000).toFixed(2)+'亿'
    }
    return res;
  }else{
    // 不为数字的话返回‘--’
    return '--'||num;
  }
})
Vue.filter("energyFormatVal", (num) => {
  // console.log('isNumber1 :>> ', num,isNumber(num));
  if(isNumber(num)){
    // console.log('isNumber :>> ', num);
    let res='';
    if(Math.abs(num)<100){
      res=num.toFixed(2);
    }else if(Math.abs(num)>=100&&Math.abs(num)<10000){
      res=num.toFixed(0);
    }else if(Math.abs(num)>=10000&&Math.abs(num)<100000000){
      res=(num/10000).toFixed(2)
    }
    else if(Math.abs(num)>=100000000){
      res=(num/100000000).toFixed(2)
    }
    return res;
  }else{
    return  '--'|| num;
  }
})
Vue.filter("carbonFormatVal", (num) => {
  // console.log('isNumber1 :>> ', num,isNumber(num));
  if(isNumber(num)){
    // console.log('isNumber :>> ', num);
    let res='';
    if(Math.abs(num)<100){
      res=num.toFixed(2);
    }else if(Math.abs(num)>=100&&Math.abs(num)<10000){
      res=num.toFixed(0);
    }else if(Math.abs(num)>=10000&&Math.abs(num)<100000000){
      res=(num/10000).toFixed(2)
    }
    else if(Math.abs(num)>=100000000){
      res=(num/100000000).toFixed(2)
    }
    return res;
  }else{
    return '--'||num;
  }
})
// 根据最大数据转化其他数据
Vue.filter("energyFormatMaxVal", (num) => {
  // console.log('isNumber1 :>> ', num,isNumber(num));
  if(isNumber(num)){
    // console.log('isNumber :>> ', num);
    let res='';
    if(Math.abs(num)<100){
      res=100;
    }else if(Math.abs(num)>=100&&Math.abs(num)<10000){
      res=1000;
    }else if(Math.abs(num)>=10000&&Math.abs(num)<100000000){
      res=10000
    }
    else if(Math.abs(num)>=100000000){
      res=100000000
    }
    return res;
  }else{
    return num;
  }
})
Vue.filter("energyFormatUnit", (num) => {
  // console.log('isNumber1 :>> ', num,isNumber(num));
  if(isNumber(num)){
    // console.log('isNumber :>> ', num);
    let res='';
    if(Math.abs(num)<100){
      res='';
    }else if(Math.abs(num)>=100&&Math.abs(num)<10000){
      res='';
    }else if(Math.abs(num)>=10000&&Math.abs(num)<100000000){
      res='万'
    }
    else if(Math.abs(num)>=100000000){
      res='亿'
    }
    return res;
  }else{
    return '';
  }
})
// ICountUp保留小数
Vue.filter("decimal", (num) => {
    let res='';
    if(Math.abs(num)<100||Math.abs(num)>=10000&&Math.abs(num)<100000000||Math.abs(num)>=100000000){
      res=2;
    }else if (Math.abs(num)>=100&&Math.abs(num)<10000){
      res=0;
    }
    return res;
})

// 数值保留小数
Vue.filter("decimals", (num) => {
    let res='';
    if(Math.abs(num)<100||Math.abs(num)>=10000&&Math.abs(num)<100000000||Math.abs(num)>=100000000){
      res=Number(num).toFixed(2);
    }else{
      res=Number(num);
    }
    return res;
})
// 字典翻译过滤器
Vue.filter('translate', function(
  value = '',
  dict = [],
  options = {
    value: 'value',
    label: 'label',
  }
) {
  if (!value && value !== 0) return '';
  let label = '';
  value = value.toString();
  for (let index = 0, len = dict.length; index < len; index++) {
    let dictValue = dict[index][options.value].toString();
    if (value === dictValue) {
      label = dict[index][options.label];
      break;
    }
  }
  return label;
});
Vue.filter('meteorologicalUnit',(num) =>{
  if (isNumber(num)) {
    return num
  }else{
    let res = parseFloat(num) //km/h
    return  res =   (res/3.6).toFixed(2)  // m/s
  }
})